<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <info-modal ref="infoModal"></info-modal>
    <show-errors-modal ref="errorsModal"></show-errors-modal>
    <div>
      <transition name="fade" mode="out-in" v-if="selectedValidationProject === null">
        <search-box-validation ref="searchBoxValidation" style="margin-top: 150px"
                               @onToggleSelectedProject="onToggleSelectedProject"></search-box-validation>
      </transition>
      <g-map-data-validation v-if="!selectedEvent" @onMapClicked="onMapClicked" @onMapLoaded="onMapLoaded"
                             @onSelectValidationDevice="onSelectValidationDevice"></g-map-data-validation>


      <div v-if="selectedValidationProject">
        <div class="is-flex is-flex-direction-column">
          <div class="is-flex has-background-primary title-box p-1 has-text-white" v-if="selectedEvent">
            <div class="is-size-5 ml-5 mr-2 pt-1 pb-1 has-text-weight-normal">{{ selectedValidationProject.project.name }}/{{selectedDevice.name}}/<span class="has-text-weight-semibold">{{selectedEvent.id}}</span>
            </div>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        size="is-small"
                        @click="deselectEvent">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex has-background-white title-box p-1" v-else>
            <div class="is-size-5 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedValidationProject.project.name }}
            </div>
            <b-tooltip class="ml-1 mt-auto mb-auto mr-2" label="Refresh project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button aria-label="refresh"
                        size="is-small"
                        @click="onRefreshClicked">
                <b-icon icon="refresh" size="is-small"></b-icon>
              </b-button>
            </b-tooltip>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        size="is-small"
                        @click="closeProjectOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div v-if="selectedEvent" class="mb-2">
            <event-details @onUpdateConflictEvents="onUpdateConflictEvents"></event-details>
          </div>
          <div class="p-3" style="padding-bottom: 64px !important;">
            <validation-table :open-new-page="false" :selected-version="selectedDataVersion" @onUpdateConflictEvents="onUpdateConflictEvents" @onVersionChanged="onVersionChanged"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import InfoModal from "@/modules/data-processing-module/components/info-modal/info-modal.vue";
import ShowErrorsModal from "@/modules/data-processing-module/components/show-errors-modal/show-errors-modal.vue";
import {mapActions, mapGetters} from "vuex";
import SearchBoxValidation
  from "@/modules/data-validation-module/components/search-box-validation/search-box-validation.vue";
import GMapDataValidation
  from "@/modules/data-validation-module/components/g-map-data-validation/g-map-data-validation.vue";
import ValidationTable from "@/modules/data-validation-module/components/validation-table/validation-table.vue";
import EventDetails from "@/modules/data-validation-module/components/event-details/event-details.vue";

export default {
  name: "data-validation-page",
  components: {
    EventDetails,
    ValidationTable,
    GMapDataValidation,
    SearchBoxValidation,
    ShowErrorsModal,
    InfoModal
  },
  data() {
    return {
      isLoading: false,
      selectedDataVersion: 1,
      pageLimit: 1000
    }
  },
  methods: {
    ...mapActions({
      setSelectedValidationProject: 'dataValidationModule/setSelectedValidationProject',
      setSelectedValidationDevice: 'dataValidationModule/setSelectedValidationDevice',
      updateConflictEvents: 'dataValidationModule/updateEvents',
      selectEvent: 'dataValidationModule/selectEvent',
    }),
    async onRefreshClicked() {
      this.isLoading = true
      const response = await this.setSelectedValidationProject(this.selectedValidationProject.project)
      console.log('Response: ', response)
      if (response instanceof Error && response.errorMessage) {
        this.showToast(response.errorMessage, 'is-danger')
      }
      this.isLoading = false
      // console.log("PROJECT: ", this.selectedProcessingProject.project)
    },
    async onToggleSelectedProject(project) {
      console.log('Selected project validation: toggle', project)
      if (project === null) {
        await this.setSelectedValidationProject(null)
      } else {
        this.isLoading = true
        const response = await this.setSelectedValidationProject(project)
        console.log('Response: ', response)
        if (response instanceof Error) {
          this.showToast(response.message, 'is-danger')
        }
        this.isLoading = false
      }
    },
    async onUpdateConflictEvents(payload){
      console.log('Call update conflict events: ', payload)
      let data = {
        payload: payload,
        dataDeviceId: this.selectedDevice._id
      }
      this.isLoading = true
      await this.updateConflictEvents(data)
      this.isLoading = false
    },
    async onVersionChanged(version) {
      this.isLoading = true
      this.selectedDataVersion = version
      let payload = {
        validationDevice: this.selectedDevice,
        dataDeviceId: this.selectedDevice._id,
        version: version,
        pageLimit: this.pageLimit,
        pageStart: 0
      }
      await this.setSelectedValidationDevice(payload)
      this.isLoading = false
      console.log('Validation table data: ', this.tableData)
    },
    async onSelectValidationDevice(device) {
      this.isLoading = true
      this.selectedDataVersion = device.dataVersions && device.dataVersions.length > 0 ? device.dataVersions[0] : 1
      let payload = {
        validationDevice: device,
        dataDeviceId: device._id,
        //dataDeviceId: '67dcd0a8f676df9ac9a726e0',
        version: this.selectedDataVersion,
        pageLimit: this.pageLimit,
        pageStart: 0
      }
      await this.setSelectedValidationDevice(payload)
      this.isLoading = false
      console.log('Validation table data: ', this.tableData)
    },
    closeProjectOverview() {
      this.setSelectedValidationProject(null)
    },
    deselectEvent() {
      this.selectEvent(null)
    },
    onMapClicked() {
      console.log('On map clicked')
      if (this.$refs.searchBoxValidation) {
        this.$refs.searchBoxValidation.onClickedOutside()
      }
      console.log('Selected Validation Project: ', this.selectedValidationProject)
    },
    onMapLoaded() {
      console.log('On map loaded')
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    }
  },
  computed: {
    ...mapGetters({
      selectedValidationProject: 'dataValidationModule/getSelectedValidationProject',
      selectedDevice: 'dataValidationModule/getSelectedValidationDevice',
      tableData: 'dataValidationModule/getValidationTable',
      selectedEvent: 'dataValidationModule/getSelectedEvent',
    })
  }
}
</script>


<style scoped>

</style>